import { Component, Field } from '@contember/interface'

export const ArticlesPreview = Component(() => (
	<div>
		<Field field="title" />
	</div>
))
